export enum StepType {
  Info = "info",
  QuestionSet = "field_set",
  Question = "field",
  Decision = "decision",
  Action = "action",
  // AddItems = "add_items",
  // SetVariables = "set_variables",
}
